'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthFromNow.js
// module id = 717
// module chunks = 0